export type Station = {
  id: number;
  nameRu: string;
  routeId: number;
  pos: number;
};

export type RouteZone = {
  id: number;
  routeId: number;
  zoneId: number;
  stationFromId: number;
  stationToId: number;
};

export type TTariffType = {
  id: number;
  nameHy: string;
  nameEn: string;
  nameRu: string;
  main: boolean;
};

export const enum EDiscountRulesType {
  commission = 0,
  discount = 1,
  fixPrice = 2,
}
export const enum EDiscountRulesTerminalType {
  web = 101,
}

export type TDiscountRules = {
  type: EDiscountRulesType; // тип скидки
  amount: number | null; // Сумма скидки (null - не использовать)
  percent: number | null; // Процент скидки (null - не использовать)
  fromPayDate: string | null; // Действует с даты оплаты (null - не использовать условие), Date JSON
  toPayDate: string | null; // Действует по дату оплаты (null - не использовать условие), Date JSON
  fromTripDate: string | null; // Действует с даты начала рейса (null - не использовать условие),  Date JSON
  toTripDate: string | null; // Действует по дату начала рейса (null - не использовать условие), Date JSON
  terminalTypeId: EDiscountRulesTerminalType | null; // Действует только с этим типом терминала (null - не использовать условие)
};

export type TTariff = {
  id: number;
  zone: { id: number };
  trainType: { id: number };
  tariffType: TTariffType;
  price: number;
  maxCountPerTicket: number; // if maxCountPerTicket === 0, then no restrictions
  discountRules: TDiscountRules[] | null;
};

export type TripRoute = { id: number; nameRu: string, number: string;  };

export type SelectedTrip = {
  trainType: { nameRu: string; id: number };
  startTime: string;
  finishTime: string;
  wagons?: TWagon[];
};

export type CalculatedTariff = {
  id: number;
  price: number;
  count: number;
  main: boolean;
  discountRules: TDiscountRules[] | null;
};

export type TripData = {
  trip: SelectedTrip;
  route: TripRoute;
  routeStations: { station: Station }[];
  routeStationZones: RouteZone[];
  tariffs: TTariff[];
};

export type NewTicketPayment = {
  payReturnUrl: string;
  payType: number;
  tripId: number;
  stationFromId: number;
  stationToId: number;
  ticketItems: { tariffId: number; count: number }[];
};

export type CreatedPayment = {
  id: number;
  personId: number;
  date: string;
  type: number;
  shared: false;
  description: string;
  payId: null | number;

  paySumm: number;
  // paySummWithCommiss: number;
  // payCommission: number;

  tripId: number;
  stationZoneId: number;
  ticketItems: { count: number; tariffId: number }[];
  payTicketQr: null | string;
  payTerminalId: number;
  payCheckNumber: number;
  payType: number;
  payReturnUrl: string;
  payConfirmationUrl: string;
  payConfirmationStatus: number;
  payRemoteId: string;
};

export type TWagonSeat = {
  number: number;
  // type: 0;
  status: ESeatStatus;
  bookingExpDate: string | null;
};
export type TWagon = {
  number: number;
  typeId: number;
  direction: null | 'forward' | 'backward';
  seats: TWagonSeat[];
};

export const enum ESeatStatus {
  free = 0,
  sold = 1,
  booked = 2,
}

export type NewBookSeat = {
  payReturnUrl: string;
  payType: 1;
  tripId: number;
  stationToId: number;
  stationFromId: number;
  tickets: {
    seatNum?: number;
    wagonNum?: number;
    tariffId: number;
  }[];
};
